import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";

interface CustomDatePickerProps {
  label: string;
  value: Dayjs;
  onChange: (value: Dayjs | null) => void;
  maxDate?: Dayjs;
  disabled?: boolean;
  className?: string;
  inputFormat?: string;
  size?: "small" | "medium";
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  label,
  value,
  onChange,
  maxDate = dayjs(),
  disabled = false,
  className,

  inputFormat = "DD-MM-YYYY",
  size = "small",
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} className={className}>
      <DatePicker
        label={label}
        inputFormat={inputFormat}
        value={value}
        maxDate={maxDate}
        onChange={onChange}
        renderInput={(props) => (
          <TextField
            {...props}
            inputProps={{
              ...props.inputProps,
              readOnly: true,
            }}
            disabled={disabled}
            size={size}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;